import { render, staticRenderFns } from "./SubscriptionModal.vue?vue&type=template&id=5b138d23&scoped=true"
import script from "./SubscriptionModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionModal.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionModal.vue?vue&type=style&index=0&id=5b138d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b138d23",
  null
  
)

export default component.exports